import React from "react";
import { create } from "zustand";
import { toast } from "react-toastify";
import {
  getComplaintIncentivesData,
  getComplaintIncentivesFilterData,
} from "../api";

export const useComplaintIncentives = create((set) => ({
  complaintIncentivesData: {
    headers: [],
    total_row_count: 0,
    page_number: 0,
    page_size: 0,
    view_type: "",
    is_downloadable: false,
    rows_data: [],
    others: {},
  },
  complaintIncentivesLoading: false,
  complaintIncentivesError: null,
  complaintIncentivesFilterData: [],
  complaintIncentivesFilterDataLoading: false,
  complaintIncentivesFilterDataError: null,
  fetchComplaintIncentives: async (params) => {
    try {
      set({ complaintIncentivesDataLoading: true });
      const response = await getComplaintIncentivesData(params);
      set({ complaintIncentivesData: response.data });
    } catch (error) {
      set({ complaintIncentivesDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ complaintIncentivesDataLoading: false });
    }
  },
  fetchComplaintIncentivesFilter: async (params) => {
    try {
      set({ complaintIncentivesFilterDataLoading: true });
      const response = await getComplaintIncentivesFilterData(params);
      set({ complaintIncentivesFilterData: response.data });
    } catch (error) {
      set({ complaintIncentivesFilterDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ complaintIncentivesFilterDataLoading: false });
    }
  },
}));
